export const fontsStyles = `
        @import url('https://fonts.googleapis.com/css?family=IBM+Plex+Sans:400,500');
        @import url('https://fonts.googleapis.com/css?family=Source+Sans+Pro:400,700');
        @import url('https://fonts.googleapis.com/css?family=Inconsolata');
        @import url('https://cdn.mathpix.com/fonts/cmu.css');
`;
